// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {Component, Inject, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ApiService} from "../../services/api/api.service";
import {DateTimePeriodService} from "../../services/date-time-period.service";
import {takeUntil, tap} from "rxjs/operators";

import {NotificationService} from "../../services/notification.service";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {SharedModule} from "../../shared/modules/shared-module.module";
import {DropFileSelectorComponent} from "../../components/drop-file-selector/drop-file-selector.component";
import {CollectDataInsertRequest} from "../../_models/data-collection";
import { Subject } from "rxjs";

@Component({
    selector: 'file-upload',
    templateUrl: 'upload-form.component.html',
    imports: [
        SharedModule,
        SelectSearchComponentComponent,
        DropFileSelectorComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class UploadFormDialogComponent implements OnInit, OnDestroy {
    file: any;
    add_mappers: boolean = false;
    non_time_series: boolean = false;
    add_series: boolean = false;
    row_major: boolean = false;
    override: boolean = false;
    collector: any;
    fileToUpload: File = null;
    showing_hints: boolean = false;
    hint: string = 'Name';

    private readonly onDestroy = new Subject<void>();

    constructor(
        public api: ApiService,
        public dialogRef: MatDialogRef<UploadFormDialogComponent>,
        public dateTimePeriodService: DateTimePeriodService,
        private notification: NotificationService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
    }


    handleFileInput(file: File) {
        this.fileToUpload = file;
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    uploadData() {
        const request: CollectDataInsertRequest = {
            file: this.fileToUpload,
            create_mappers: this.add_mappers.toString(),
            create_series_list: this.add_series.toString(),
            row_major: this.row_major.toString(),
            override: this.override.toString(),
            name: this.collector.attributes.name,
            non_time_series: this.non_time_series.toString(),
        };

        this.api.uploadCollectionEvents(request).pipe(
            tap({
                next: (response: any): void => {
                    if (Array.isArray(response.errors)) {
                        this.notification.openError(response.errors.join(''));
                    } else {
                        this.notification.openSuccess('File collected successfully.');
                    }
                }, error: (err: any): void => {
                    console.error('Error uploading collector data', err);
                    this.notification.openError('An error occurred while collecting the file.');
                }
            }), takeUntil(this.onDestroy)).subscribe();
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }
}
